/** 门店管理API */
import type { FlatResponseData } from '@sa/axios';
import type { Api } from '@/typings/api';
import { download, get, post } from '../../request';
const prefix = '/store/storeInfo';
/**
 * 分页查询门店管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Store.StoreInfo> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询门店管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Store.StoreInfo> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个门店管理
 *
 * @param id 门店管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Store.StoreInfo> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 当前用户门店预约时间点
 *
 * @returns
 */
export const findAppointmentTime = (customerId?: string): Promise<FlatResponseData<string[]>> => {
  return get(`${prefix}/findAppointmentTime`, {
    customerId
  });
};
/**
 * 保存门店管理
 *
 * @param params 门店管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新门店管理信息
 *
 * @param params 门店管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除门店管理
 *
 * @param id 门店管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除门店管理
 *
 * @param ids 门店管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
